import type { Components } from '@/api/generated/api';
import type { AnalyticsUserProperties } from '@/services/analytics';
import { getCurrentRole } from '@/utils/role.utils';

export type AnalyticsUserRole = Components.Schemas.UserRoleType | 'anonymous';

export type UserRoleUserProperties = AnalyticsUserProperties & {
  user_role: AnalyticsUserRole;
};

export const ANONYMOUS_USER_ROLE_USER_PROPERTIES: UserRoleUserProperties = {
  user_role: 'anonymous',
};

export type UserRoleUserPropertiesContext = {
  currentTenant: Components.Schemas.TenantDto | null;
  isLoggedIn: boolean;
  whoAmI: Components.Schemas.WhoAmIDataDto | null;
};

export function buildUserRoleAnalyticsUserProperties(
  context: UserRoleUserPropertiesContext,
): UserRoleUserProperties | null {
  if (!context.isLoggedIn || !context.currentTenant) {
    return ANONYMOUS_USER_ROLE_USER_PROPERTIES;
  }

  if (!context.whoAmI) {
    return null;
  }

  const currentRole = getCurrentRole(context.whoAmI);
  if (!currentRole) {
    return null;
  }

  if (currentRole.tenant.id !== context.currentTenant.id) {
    return null;
  }

  return {
    user_role: currentRole.roleType,
  };
}
